
<!-- General -->
<div *appRoles="['Dashboard.Listar']">
    <app-dashboard-general></app-dashboard-general>
</div>
